import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "@reach/router";
import { useEthers } from "@usedapp/core";
import axios from "axios";
import { LoadingModal } from "../ui/Modals";
import { useContractContext } from "../../hooks/useContractContext";

// for owner view

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? "active" : "non-active",
      };
    }}
  />
);

const Responsive = () => {
  const { licensesContract } = useContractContext();
  const { activateBrowserWallet, account } = useEthers();
  const [smartContractData, setSmartContractData] = useState([]);
  const [noLicenseDetected, setNoLicenseDetected] = useState(true);

  const [nftData, setNftData] = useState({
    nfts: [].slice(0, 8),
    height: 0,
  });

  const formatIpfsUrl = (url) => {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        var numTokensOwned = Number(await licensesContract.balanceOf(account));
        if (numTokensOwned > 0) {
          setNoLicenseDetected(false);
        }
      } catch (err) {
        setNoLicenseDetected(true);
        return;
      }
      if (noLicenseDetected === false || numTokensOwned > 0) {
        const tempArray = [numTokensOwned - 1];
        // loop over licenseTokenIds to pull data from both copyrights_contract & Marketplace_contract
        for (let index = 0; index < numTokensOwned; index++) {
          var licenseTokenId = await licensesContract.tokenOfOwnerByIndex(
            account,
            index
          );
          var licenseReference = await licensesContract.checkLicenseReference(
            licenseTokenId
          );
          var licenseURI = await licensesContract.tokenURI(licenseTokenId);
          var formattedUri = formatIpfsUrl(licenseURI);
          var MetaData = (await axios.get(formattedUri)).data;
          tempArray[index] = {
            licenseTokenId,
            licenseURI,
            MetaData,
            licenseReference,
          };
        }
        // save data into a constant that can be passed to other components
        setSmartContractData(tempArray);
      }
    };
    if (account) {
      fetchData();
    } else {
      activateBrowserWallet();
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  useEffect(() => {
    setNftData((prevState) => ({
      ...prevState,
      nfts: smartContractData.slice(0, 8),
    }));
  }, [smartContractData]);

  function onImgLoad({ target: img }) {
    let currentHeight = nftData.height;
    if (currentHeight < img.offsetHeight) {
      setNftData((prevState) => ({ ...prevState, height: img.offsetHeight }));
    }
  }

  function loadMore() {
    const nftState = nftData.nfts;
    const end = nftState.length + 4;
    setNftData((prevState) => ({
      ...prevState,
      nfts: smartContractData.slice(0, end),
    }));
  }

  return (
    <div className="row">
      {!account && (
        <div>
          Unable to detect a wallet. Please connect your wallet and try again.
        </div>
      )}
      {noLicenseDetected && (
        <div>
          No license tokens detected in your wallet, please purchase a license
          and try again
        </div>
      )}
      {account && smartContractData.length === 0 && !noLicenseDetected && (
        <LoadingModal title={"Loading Data..."} />
      )}
      {!noLicenseDetected &&
        nftData.nfts.map((nft, _tokenID) => (
          <div
            key={_tokenID}
            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
          >
            <div className="nft__item">
              <div
                className="nft__item_wrap"
                style={{ height: `${nftData.height}px` }}
              >
                <Outer>
                  <span>
                    <NavLink to={`/LicenseDetails/${nft.licenseTokenId}`}>
                      <img
                        onLoad={onImgLoad}
                        src={formatIpfsUrl(nft.MetaData.imageCID)}
                        className="lazy nft__item_preview"
                        alt=""
                      />
                    </NavLink>
                  </span>
                </Outer>
              </div>
              <div className="nft__item_info">
                <div>
                  <b>License TokenId</b> : {`${nft.licenseTokenId}`}
                </div>
                <div>
                  <b>Creator</b> :{" "}
                  {`${nft.licenseReference.copyrightOwner}`.slice(0, 25)}....
                </div>

                <div className="nft__item_price">
                  {nft.price}
                  <span>{""}</span>
                </div>
                <div className="nft__item_action">
                  <NavLink to={`/LicenseDetails/${nft.licenseTokenId}`}>
                    <span>View Details</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        ))}
      {nftData.nfts.length !== smartContractData.length && (
        <div className="col-lg-12">
          <div className="spacer-single"></div>
          <span onClick={() => loadMore()} className="btn-main lead m-auto">
            Load More
          </span>
        </div>
      )}
    </div>
  );
};

export default Responsive;
